import * as keyapis_identity_v1_authorization_pb from "./v1/keyapis_identity_authorization_v1.pb";
import * as keyapis_identity_v1_oauth2_pb from "./v1/keyapis_identity_oauth2_v1.pb";
import * as keyapis_identity_v1_system_pb from "./v1/keyapis_identity_system_v1.pb";
import * as keyapis_identity_v1_token_pb from "./v1/keyapis_identity_token_v1.pb";
import * as keyapis_identity_v1_user_pb from "./v1/keyapis_identity_user_v1.pb";

export default {
  v1: {
    resources: {
      authorization: keyapis_identity_v1_authorization_pb,
      oauth2: keyapis_identity_v1_oauth2_pb,
      system: keyapis_identity_v1_system_pb,
      token: keyapis_identity_v1_token_pb,
      user: keyapis_identity_v1_user_pb,
    },
  },
};
